import React from 'react';
import { handleize } from '../../../../utils/handleize';
import { Ssvg } from '../../../../Components/react/Ssvg';
import { dlDispatchAmplEvent } from '../../../../events/dl.dispatchAmplEvent';
export const InfoAccordion = ({ title, children }) => {
    return (React.createElement("accordion-component", { class: "d:block w:100p bd bd:tw:1 last:bd:bw:1 bd:c:border-light" },
        React.createElement("h2", { className: "m:0 fz:16 fw:400" },
            React.createElement("button", { className: "btn:cleared d:flex ai:center jc:between w:100p py:10 py:14:xl-up pr:10:xl-up", "aria-expanded": false, "aria-controls": `pp-info-${handleize(title)}`, onClick: (event) => {
                    dlDispatchAmplEvent('Product details', {
                        name: title,
                        action: event.currentTarget.ariaExpanded === 'true' ? 'expand' : 'collapse'
                    });
                } },
                React.createElement("span", { className: "lts:002" }, title),
                React.createElement(Ssvg, { icon: "#icon--flex-plus", className: "h:12 w:12 op:0.5" }))),
        React.createElement("div", { id: `pp-info-${handleize(title)}`, "data-state-expanded": false, className: "w:100vw mx:-pw px:pw w:100p:lg-up mx:0:lg-up px:0:lg-up" },
            React.createElement("div", { className: "fz:14 lts:001 lh:1.6 mt:-2 pb:10 pb:14:xl-up color:text-middle" }, children))));
};
